const PATH = 'fe.components.organization.hierarchy';

const messages = {
  hierarchySearch: {
    placeholder: {
      key: `${PATH}.hierarchy_search.placeholder`,
      defaultValue: 'Search hierarchy level'
    }
  },
  clearAll: {
    key: `${PATH}.clear_all`,
    defaultValue: 'Clear all'
  },
  invalidTagName: {
    key: `${PATH}.invalid_tag_name`,
    defaultValue: 'Invalid Node'
  },
  hierarchyNotice: {
    key: `${PATH}.hierarchy_notice`,
    defaultValue:
      'Select all that apply. Note: Users with a role of Administrator must belong to one or more areas of an organization.'
  },
  accountLabel: {
    key: `${PATH}.account_label`,
    defaultValue: 'Account'
  },
  hierarchyAssocLabel: {
    key: `${PATH}.hierarchy_assoc_label`,
    defaultValue: 'Hierarchy Association'
  },
  primaryAdminHierarchyInfo: {
    key: `${PATH}.primary_admin_hierarchy_info`,
    defaultValue: 'Primary Admins always have access to the entire hierarchy.'
  }
};

export default messages;
